import FailsafeImg from 'components/global/application/FailsafeImg';
import React from 'react';

import { BREAK_POINT } from 'constants/responsive';
import { imageUrlAppendStyle } from 'contexts/link_util';

import './NewsFeedItem.sass';

interface NewsFeedItemProps {
    className?: string;
    description: string;
    imgUrl: string;
    url: string;
}

const NewsFeedItem: React.StatelessComponent<NewsFeedItemProps> = (props: NewsFeedItemProps) => {
    return(
        <div className={`NewsFeedItem-container${window.innerWidth < BREAK_POINT ? '-mobile' : ''}${props.className ? ` ${props.className}` : ''}`}>
            <div className="Thumbnail"><FailsafeImg src={imageUrlAppendStyle(props.imgUrl, 'thumbnail')} /></div>
            <div className="Info">
                <span className="Description">{props.description}</span>
                <span className="Read-more"><a href={props.url}>Read More</a></span>
            </div>
        </div>
    );
};

export default NewsFeedItem;



// WEBPACK FOOTER //
// ./src/components/global/application/NewsFeedItem.tsx